export type UserStatus = 'Account Created' | 'Setup Pending' | 'Invite Expired'
export type UserRole = 'Facilitator' | 'Participant' | 'Admin'

export interface UserRow {
	company: string
	firstName: string
	id: number
	lastName: string
	licenseExpiration: string
	licensesAllotted: number
	licensesUsed: number
	userEmail: string
	userRole: string
	userStatus: UserStatus
}

export const adminDummyData: UserRow[] = [
	{
		id: 1,
		company: 'IDEO',
		firstName: 'John',
		lastName: 'Doe',
		userEmail: 'john@ideo.com',
		userStatus: 'Account Created',
		userRole: 'Facilitator',
		licenseExpiration: 'Never',
		licensesUsed: 10,
		licensesAllotted: 10,
	},
	{
		id: 2,
		company: 'BCG',
		firstName: 'Jane',
		lastName: 'Doe',
		userEmail: 'jane@bcg.com',
		userStatus: 'Account Created',
		userRole: 'Facilitator',
		licenseExpiration: 'Never',
		licensesUsed: 23,
		licensesAllotted: 50,
	},
	{
		id: 3,
		company: 'Nike',
		firstName: 'James',
		lastName: 'Doe',
		userEmail: 'James@nike.com',
		userStatus: 'Setup Pending',
		userRole: 'Facilitator',
		licenseExpiration: 'Never',
		licensesUsed: 100,
		licensesAllotted: 100,
	},
	{
		id: 4,
		company: 'IBM',
		firstName: 'Janet',
		lastName: 'Doe',
		userEmail: 'Janet@IBM.com',
		userStatus: 'Invite Expired',
		userRole: 'Participant',
		licenseExpiration: 'Never',
		licensesUsed: 78,
		licensesAllotted: 100,
	},
	{
		id: 5,
		company: 'Delta',
		firstName: 'Jerome',
		lastName: 'Doe',
		userEmail: 'Jerome@delta.com',
		userStatus: 'Setup Pending',
		userRole: 'Participant',
		licenseExpiration: '9/8/25',
		licensesUsed: 5,
		licensesAllotted: 20,
	},
	{
		id: 6,
		company: 'Apple',
		firstName: 'Janice',
		lastName: 'Doe',
		userEmail: 'Janice@apple.com',
		userStatus: 'Invite Expired',
		userRole: 'Participant',
		licenseExpiration: '10/10/26',
		licensesUsed: 0,
		licensesAllotted: 15,
	},
	{
		id: 7,
		company: 'Slalom Consulting',
		firstName: 'Jake',
		lastName: 'Doe',
		userEmail: 'Jake@slalom.com',
		userStatus: 'Account Created',
		userRole: 'Admin',
		licenseExpiration: 'Never',
		licensesUsed: 30,
		licensesAllotted: 50,
	},
	{
		id: 8,
		company: 'Slalom Consulting',
		firstName: 'Jake',
		lastName: 'Doe',
		userEmail: 'Jake@slalom.com',
		userStatus: 'Account Created',
		userRole: 'Admin',
		licenseExpiration: 'Never',
		licensesUsed: 30,
		licensesAllotted: 50,
	},
	{
		id: 9,
		company: 'Slalom Consulting',
		firstName: 'Jake',
		lastName: 'Doe',
		userEmail: 'Jake@slalom.com',
		userStatus: 'Account Created',
		userRole: 'Admin',
		licenseExpiration: 'Never',
		licensesUsed: 30,
		licensesAllotted: 50,
	},
	{
		id: 10,
		company: 'Slalom Consulting',
		firstName: 'Jake',
		lastName: 'Doe',
		userEmail: 'Jake@slalom.com',
		userStatus: 'Account Created',
		userRole: 'Admin',
		licenseExpiration: 'Never',
		licensesUsed: 30,
		licensesAllotted: 50,
	},
	{
		id: 11,
		company: 'Slalom Consulting',
		firstName: 'Jake',
		lastName: 'Doe',
		userEmail: 'Jake@slalom.com',
		userStatus: 'Account Created',
		userRole: 'Admin',
		licenseExpiration: 'Never',
		licensesUsed: 30,
		licensesAllotted: 50,
	},
	{
		id: 12,
		company: 'Slalom Consulting',
		firstName: 'Jake',
		lastName: 'Doe',
		userEmail: 'Jake@slalom.com',
		userStatus: 'Account Created',
		userRole: 'Admin',
		licenseExpiration: 'Never',
		licensesUsed: 30,
		licensesAllotted: 50,
	},
	{
		id: 13,
		company: 'Slalom Consulting',
		firstName: 'Jake',
		lastName: 'Doe',
		userEmail: 'Jake@slalom.com',
		userStatus: 'Account Created',
		userRole: 'Admin',
		licenseExpiration: 'Never',
		licensesUsed: 30,
		licensesAllotted: 50,
	},
]
